import React, { useEffect, useRef, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import { FiUser, FiStar, FiHome, FiBook, FiVideo } from "react-icons/fi";
import { cookies } from "../axios/axios";
import logo from "../images/logo.jpg";
import axios from "../axios/axios";
import GoogleAnalytics from "./GoogleAnalytics";

const user = cookies.get("user");

const serviceLinks = [
  { to: "/color-correction", label: "Color Correction", icon: <FiUser /> },
  { to: "/retouching", label: "Retouching", icon: <FiStar /> },
  { to: "/real-estate", label: "Real Estate", icon: <FiHome /> },
  { to: "/album-editing", label: "Album Editing", icon: <FiBook /> },
  { to: "/video-editing", label: "Video Editing", icon: <FiVideo /> },
];

const Navbar = () => {
  const navigate = useNavigate();
  const [servicesOpen, setServicesOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      const user = cookies.get("user");
      const refreshToken = user?.tokens?.refresh?.token;

      if (!refreshToken) {
        console.error("Refresh token not found in cookie");
        return;
      }

      await axios.post("/auth/logout", { refreshToken });

      cookies.remove("user");

      // (Optional) if you want to remove any other separate tokens:
      // cookies.remove("refreshToken");

      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error.response?.data || error.message);
    }
  };

  return (
    <>
      <GoogleAnalytics />
      <nav className="navbar navbar-expand-lg navbar-white bg-white site-navbar">
        <div className="container-fluid mx-4">
          <Link to={"/"} className="navbar-brand">
            <img
              src={logo}
              width={180}
              height={80}
              className="object-fit-contain"
              alt=""
            />
          </Link>
          <button
            className="navbar-toggler shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink to={"/"} end className="nav-link px-0">
                  Home
                </NavLink>
              </li>
              {user && (
                <li className="nav-item">
                  <NavLink to={"/user-dashboard"} className="nav-link px-0">
                    Dashboard
                  </NavLink>
                </li>
              )}
              <li className="nav-item">
                <div className="services-dropdown" ref={dropdownRef}>
                  <button
                    type="button"
                    className={`nav-link services-dropdown-btn px-0 ${
                      servicesOpen ? "active" : ""
                    }`}
                    onClick={() => setServicesOpen((prev) => !prev)}
                    aria-expanded={servicesOpen}
                  >
                    Services
                    <IoMdArrowDropdown
                      className={`services-dropdown-caret ${
                        servicesOpen ? "open" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`services-dropdown-menu ${
                      servicesOpen ? "open" : ""
                    }`}
                  >
                    {serviceLinks.map((service) => (
                      <Link
                        key={service.to}
                        to={service.to}
                        onClick={() => setServicesOpen(false)}
                      >
                        <span className="services-dropdown-icon">
                          {service.icon}
                        </span>
                        {service.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <NavLink to={"/blogs"} className="nav-link px-0">
                  Blog
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={"/contact-us"} className="nav-link px-0">
                  Contact Us
                </NavLink>
              </li>
            </ul>
            <div className="d-flex gap-2">
              <Link to={"/free-trial"}>
                <button
                  className="btn bg_maincolor text-white"
                  type="submit"
                >
                  Get Started
                </button>
              </Link>

              {user ? (
                <div className="dropdown">
                  <button
                    className="btn shadow-none border-0 text_maincolor dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {user?.user?.fname}
                  </button>
                  <ul
                    className="dropdown-menu w-100"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="w-100">
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              ) : (
                <Link to={"/login"}>
                  <button
                    className="btn text_maincolor border_maincolor"
                    type="submit"
                  >
                    Log In
                  </button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Navbar;
